import { combineReducers } from 'redux';
import common from './common';
import ui from './ui';

export default combineReducers({ common, ui });
